
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M1.82 3.69h36.36V38.5H1.82zM10.83.5v6.38M20 .5v6.38M29.17.5v6.38M2.23 12.59h35.54"}}),_c('path',{attrs:{"fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2","d":"M20 17.75l2.48 5.03 5.56.81-4.02 3.92.95 5.53L20 30.43l-4.97 2.61.95-5.53-4.02-3.92 5.56-.81L20 17.75z"}})])
          )
        }
      }
    